import { render, staticRenderFns } from "./ListTokenRole.vue?vue&type=template&id=878f2bc8&scoped=true"
import script from "./ListTokenRole.vue?vue&type=script&lang=js"
export * from "./ListTokenRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878f2bc8",
  null
  
)

export default component.exports